import React from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide shadow-lg transform active:scale-95 duration-100';
  const variants = {
    primary: 'bg-gradient-to-r from-[#C084FC] to-[#E879F9] hover:from-[#A855F7] hover:to-[#D946EF] text-white border-b-4 border-[#7C3AED] active:border-b-0 active:mt-1 shadow-[0_4px_20px_rgba(192,132,252,0.5)]',
    secondary: 'bg-gradient-to-r from-[#F472B6] to-[#C084FC] hover:from-[#EC4899] hover:to-[#A855F7] text-white border-b-4 border-[#9333EA] active:border-b-0 active:mt-1 shadow-[0_4px_20px_rgba(244,114,182,0.5)]',
    outline: 'border-2 border-[#C084FC] text-[#9333EA] hover:bg-purple-50'
  };
  const sizes = {
    default: 'h-10 py-2 px-4 text-sm',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl md:text-2xl'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], fullWidth && 'w-full', className)} {...props} data-id="element-296">
      {children}
    </button>;
}